import { render } from "./ActionListItem.vue?vue&type=template&id=48a5ceb6"
import script from "./ActionListItem.vue?vue&type=script&lang=js"
export * from "./ActionListItem.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__